"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _Paragraph = _interopRequireDefault(require("../../elements/Paragraph/Paragraph"));
var _ThreeColumnLayout = _interopRequireDefault(require("../../layouts/ThreeColumnLayout/ThreeColumnLayout"));
var _PageGrid = _interopRequireDefault(require("../../layouts/Skeletons/PageGrid/PageGrid"));
var _excluded = ["className", "children"],
  _excluded2 = ["className", "children"],
  _excluded3 = ["columnCopy"],
  _excluded4 = ["node"],
  _excluded5 = ["node"],
  _excluded6 = ["node"],
  _excluded7 = ["node"],
  _excluded8 = ["partnerWithUsContent", "PartnerWithUsVariant"];
var _templateObject, _templateObject2, _templateObject3;
var MarkdownColumnBody = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_Paragraph.default, Object.assign({
    className: className
  }, props), " ", children, " ");
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var MarkdownColumnHeading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return _react.default.createElement(_Heading.default, Object.assign({
    h2: true,
    special: true,
    className: className
  }, props), " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  strong {\n    color: var(--bf-core-pink);\n  }\n  color: var(--bf-dark-grey);\n  margin-top: 35px !important;\n  margin-bottom: 15px !important;\n  text-align: center;\n"])));
var StyledColumn = (0, _styledComponents.default)(_Grid.default)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  margin-bottom: 20px;\n"])));
function PartnerWithUsColumn(_ref3) {
  var columnCopy = _ref3.columnCopy,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Grid.default, Object.assign({
    item: true,
    xs: 12,
    sm: 12,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(_reactMarkdown.default, {
    children: columnCopy,
    components: {
      h1: function h1(_ref4) {
        var node = _ref4.node,
          props = (0, _objectWithoutProperties2.default)(_ref4, _excluded4);
        return _react.default.createElement(MarkdownColumnHeading, props);
      },
      h2: function h2(_ref5) {
        var node = _ref5.node,
          props = (0, _objectWithoutProperties2.default)(_ref5, _excluded5);
        return _react.default.createElement(MarkdownColumnHeading, props);
      },
      h3: function h3(_ref6) {
        var node = _ref6.node,
          props = (0, _objectWithoutProperties2.default)(_ref6, _excluded6);
        return _react.default.createElement(MarkdownColumnBody, props);
      },
      p: function p(_ref7) {
        var node = _ref7.node,
          props = (0, _objectWithoutProperties2.default)(_ref7, _excluded7);
        return _react.default.createElement(MarkdownColumnBody, props);
      }
    }
  })));
}
;
var PartnerWithUs = function PartnerWithUs(_ref8) {
  var partnerWithUsContent = _ref8.partnerWithUsContent,
    PartnerWithUsVariant = _ref8.PartnerWithUsVariant,
    props = (0, _objectWithoutProperties2.default)(_ref8, _excluded8);
  return _react.default.createElement(_PageGrid.default, props, _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    justifyContent: "center"
  }, props), _react.default.createElement(StyledColumn, Object.assign({
    item: true,
    xs: 11,
    justifyContent: "center",
    style: {
      textAlign: 'center'
    }
  }, props), _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true
  }, partnerWithUsContent.nodes[0].data.header), _react.default.createElement(_Heading.default, {
    h3: true,
    special: true,
    darkGrey: true
  }, partnerWithUsContent.nodes[0].data.subheader)), _react.default.createElement(_ThreeColumnLayout.default, Object.assign({
    alignItems: "flex-start",
    justifyContent: 'center'
  }, props), _react.default.createElement(PartnerWithUsColumn, Object.assign({
    columnCopy: partnerWithUsContent.nodes[1].data.header
  }, props)), _react.default.createElement(PartnerWithUsColumn, Object.assign({
    columnCopy: partnerWithUsContent.nodes[2].data.header
  }, props)), _react.default.createElement(PartnerWithUsColumn, Object.assign({
    columnCopy: partnerWithUsContent.nodes[3].data.header
  }, props)))));
};
var _default = PartnerWithUs;
exports.default = _default;